import { SearchService } from './services/search.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
// Services
import { WINDOW_PROVIDERS } from './services/windows.service';
import { LandingFixService } from '../shared/services/landing-fix.service';
import { InstagramService } from './services/instagram.service';
import { ProductsService } from './services/products.service';
import { WishlistService } from './services/wishlist.service';
import { CartService } from './services/cart.service';
import { OrderService } from './services/order.service';
import { PaginationService } from './classes/paginate';
// Pipes
import { OrderByPipe } from './pipes/order-by.pipe';
// components
import { HeaderOneComponent } from './header/header-one/header-one.component';
import { LeftSidebarComponent } from './header/left-sidebar/left-sidebar.component';
import { TopbarOneComponent } from './header/widgets/topbar/topbar-one/topbar-one.component';
import { TopbarTwoComponent } from './header/widgets/topbar/topbar-two/topbar-two.component';
import { NavbarComponent } from './header/widgets/navbar/navbar.component';
import { SettingsComponent } from './header/widgets/settings/settings.component';
import { LeftMenuComponent } from './header/widgets/left-menu/left-menu.component';
import { FooterOneComponent } from './footer/footer-one/footer-one.component';
import { InformationComponent } from './footer/widgets/information/information.component';
import { CategoriesComponent } from './footer/widgets/categories/categories.component';
import { WhyWeChooseComponent } from './footer/widgets/why-we-choose/why-we-choose.component';
import { CopyrightComponent } from './footer/widgets/copyright/copyright.component';
import { SocialComponent } from './footer/widgets/social/social.component';
import {MaterialModule} from './material.module';
import {KeysPipe} from '../directives/KeysPipe';
import {OnlynumberDirective} from '../directives/onlynumber.directive';
import {OnlydecimalnumberDirective} from '../directives/onlydecimalnumber.directive';
import {RemoveSemicolonDirective} from '../directives/remove.semicolon.directive';
import {OnlyPositivedecimalnumberDirective} from '../directives/onlyPositivedecimalnumber.directive';
import {FormsModule} from '@angular/forms';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import {MsgSnackbarComponent} from "./msg-snackbar/msg-snackbar.component";
import { MpagoService } from './services/mpago.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiInterceptorService } from './services/api-interceptor.service';
import {MyHttpInterceptor} from '../security/http.interceptor';

@NgModule({
  exports: [
    CommonModule,
    TranslateModule,
    HeaderOneComponent,
    LeftSidebarComponent,
    FooterOneComponent,
    OrderByPipe,
    KeysPipe,
    OnlynumberDirective,
    OnlydecimalnumberDirective,
    RemoveSemicolonDirective,
    OnlyPositivedecimalnumberDirective,
    MaterialModule
  ],
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        MaterialModule,
        FormsModule
    ],
  declarations: [
    HeaderOneComponent,
    LeftSidebarComponent,
    FooterOneComponent,   
    OrderByPipe,
    NavbarComponent,
    SettingsComponent,
    LeftMenuComponent,
    TopbarOneComponent,
    TopbarTwoComponent,
    InformationComponent,
    CategoriesComponent,
    WhyWeChooseComponent,
    CopyrightComponent,
    SocialComponent,
    KeysPipe,
    OnlynumberDirective,
    OnlydecimalnumberDirective,
    RemoveSemicolonDirective,
    OnlyPositivedecimalnumberDirective,
    MsgSnackbarComponent
  ],
  providers: [
    WINDOW_PROVIDERS,
    LandingFixService,
    InstagramService,
    ProductsService,
    WishlistService,
    // CartService removed - using providedIn: 'root' to ensure singleton
    OrderService,
    PaginationService,
    SearchService,
    {provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {duration: 1600}},
    {provide:HTTP_INTERCEPTORS, useClass: MyHttpInterceptor,multi:true}
  ],
  entryComponents: [MsgSnackbarComponent]
})
export class SharedModule { }
